// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__1Pmbu","HorizontalSpacer":"NavigationItems_HorizontalSpacer__36Cdu","VerticalSpacer":"NavigationItems_VerticalSpacer__1v55R"};